import React, {useCallback, useState} from "react";
import {css, Theme} from "@emotion/react";

import {display, onDesktop} from "@pg-design/helpers-css";
import {ContactIcon, MenuIcon, ShareIcon} from "@pg-design/icons-module";

import {TableOfContents} from "./TableOfContents/TableOfContents";
import {ArticleActionButton} from "./ArticleActionButton";
import {ArticleActionModal} from "./ArticleActionModal";
import {ArticleShareButtons} from "./ArticleShareButtons";

enum ArticleActionTypeEnum {
    TABLE_OF_CONTENTS = 1,
    SHARE_ARTICLE = 2
}

interface IProps {
    hasTableOfContents?: boolean;
    commentsCount?: number;
    scrollToComments: () => void;
    pathname: string;
    quote: string;
}

const TABLE_OF_CONTENTS_LABEL = "Spis treści";
const SHARE_LABEL = "Udostępnij";
const COMMENTS_LABEL = "Komentarze";

export const ArticleActionsBar = ({hasTableOfContents, commentsCount, scrollToComments, ...rest}: IProps) => {
    const [modalType, setModalType] = useState<ArticleActionTypeEnum | null>(null);
    const onModalClose = useCallback(() => setModalType(null), []);
    const onSetModalType = useCallback((type: ArticleActionTypeEnum) => setModalType(type), []);
    const showTableOfContents = modalType === ArticleActionTypeEnum.TABLE_OF_CONTENTS;
    const modalTitle = showTableOfContents ? TABLE_OF_CONTENTS_LABEL : SHARE_LABEL;

    return (
        <>
            <div css={actionBar}>
                <ArticleActionButton onClick={scrollToComments} label={COMMENTS_LABEL}>
                    <ContactIcon size="1.8" />
                    {commentsCount ? <div css={commentBadge}> {commentsCount}</div> : null}
                </ArticleActionButton>

                {hasTableOfContents && (
                    <ArticleActionButton onClick={() => onSetModalType(ArticleActionTypeEnum.TABLE_OF_CONTENTS)} label={TABLE_OF_CONTENTS_LABEL}>
                        <MenuIcon size="2" />
                    </ArticleActionButton>
                )}

                <ArticleActionButton onClick={() => onSetModalType(ArticleActionTypeEnum.SHARE_ARTICLE)} label={SHARE_LABEL}>
                    <ShareIcon size="2" />
                </ArticleActionButton>
            </div>
            <ArticleActionModal modalState={!!modalType} onModalClose={onModalClose} title={modalTitle}>
                {showTableOfContents ? (
                    <TableOfContents showHeader={false} isPlacedInModal onTableOfContentsClick={onModalClose} />
                ) : (
                    <ArticleShareButtons showLabels modalViewPlacement iconSize={46} {...rest} />
                )}
            </ArticleActionModal>
        </>
    );
};

const actionBar = css`
    overflow: auto;
    display: flex;
    z-index: 999;
    justify-content: space-around;
    align-items: flex-end;
    padding-bottom: 0.8rem;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 6rem;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19);

    ${onDesktop(display("none"))}
`;

const commentBadge = (theme: Theme) => css`
    position: absolute;
    top: -1rem;
    left: 2.2rem;
    color: #fff;
    width: 13px;
    height: 13px;
    padding: 0 0.4rem;
    background: ${theme.colors.danger};
    border-radius: 1rem;
    border: 1px solid #fff;
    font-size: 0.8rem;
    line-height: 1.2rem;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    z-index: 9999;
`;
